<template>
    <div class="days" v-if="!$apollo.loading">
        <b-dropdown :text="text" variant="default">
            <b-dropdown-item-button v-for="option in options" :key="option.value" @click.prevent="selectedOption(option)">
               {{ option.label }}
            </b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: 'filter-by-date',

    data() {
        return {
            text: 'Choose date',
            options: [
                {
                    label: 'All dates',
                    value: ''
                },
                {
                    label: 'Today',
                    value: 'today'
                },
                {
                    label: 'This week',
                    value: 'this_week'
                },
                {
                    label: 'This month',
                    value: 'this_month'
                }
            ],
        }
    },

    methods: {
        selectedOption(option = {}) {
            this.text = option.label;
            this.$emit('input', option.value);
        }
    },
}
</script>

<style lang="scss" scoped>
    .days /deep/ .dropdown-toggle {
        padding: 0;
        &:active,
        &:hover,
        &:focus {
            box-shadow: none;
        }

        &:after {
            margin-left: 14px;
            border: solid $secondary;
            border-width: 0 3px 3px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
        }
    }
</style>
